function updateRecordInline(elem) {
  $.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });
  $.ajax({
      type: "POST",
      url: elem.data('update_url'),
      dataType: "HTML",
      data: {'name': elem.val(),'id': elem.data('id')},
      success: function(data) {
      }
  });
}

function checkVies() {
  $.ajax({
      type: "POST",
      url: "/check_vies",
      dataType: "JSON",
      data: {'vatcode': $("#country").val(),'vatnumber': $("#cui").val(),'package_selected': $("#package_id").val() },
      success: function(data) {
        if(data.valid == true){
          updatePriceDescription(true);
          $(".cui-message").removeClass('hide');
        }else{
          updatePriceDescription(false);
          $(".cui-message").addClass('hide');
        }
      }
  });
}

function populateProcessesListInPopupTodo(elem) {
    var search_name = elem.val();
    var url = elem.data('url');
    var company_id = elem.data('company_id');
    var team_id = elem.data('team_id');
    var role = $('#choose-role').val();
    var objective_type = elem.data('objective_type');
    $.ajax({
        type: "POST",
        url: "/" + url,
        dataType: "HTML",
        data: {'search_name': search_name, 'company_id': company_id, 'role': role, 'team_id': team_id, 'objective_type': objective_type},
        success: function(data) {
          if(url == 'search_process_by_name_in_company'){
            $(".process-list-in-company").html(data);
          }else if(url == 'search_process_by_name'){
            $(".process-list-in-popup").html(data);
          }else if(url == 'search_strategic_action_by_name_in_objectives'){
            $(".strategic-action-list-in-objectives").html(data);
          }
        }
    });  
}

function updatePriceDescription(vies_valid) {
  country_val = $('#country').val();
  package_id = $('#package_id').val();
  $.ajax({
      type: "POST",
      url: "/check_related_package",
      dataType: "HTML",
      data: {'current_package': package_id,'vies_valid': vies_valid, selected_country: country_val},
      success: function(data) {
        $(".package-price").addClass('hide');
        $("#package_price_"+data).removeClass('hide');
        $(".package-description").addClass('hide');
        $("#package_description_"+data).removeClass('hide');
        $("#package_id").val(data);
      }
  });
}

function reinitCriticalNumberDays(holder) {
  var objective_target_days = $(holder+" #default_cn_target_days").val().split(",");
  $(holder + " #cn_target_days").val($(holder+" #default_cn_target_days").val());
  $(holder + " .dropdown-item").removeClass('checked');

  objective_target_days.forEach(function(entry) {
    $(holder + " .dropdown-item[rel='"+entry+"']").addClass('checked');
  });

  var list = '';
  $(holder + ' .dropdown-item').each(function(){
      var current_elem = $(this);
      if ($(this).hasClass('checked')) {
        if(list == ''){
          list += current_elem.html();
        }else{
          list += "," + current_elem.html();
        } 
      }
  });
  $(holder + ' .choose-days span').html(list);

  $(holder + " #cn_target_days").val($(holder+" #default_cn_target_days").val());
}

function updatePopUpHeader(){
  var finished_tasks = $('.checkbox_parent.checked').length
  var total_tasks = $('.checkbox_parent').length
  $("a[rel='planning_day'] .open").html("&nbsp;("+ finished_tasks + "/"+ total_tasks +")");  
  $("a[rel='planning_day'] .closed").html(" "+ finished_tasks + "/"+ total_tasks +"");  
}

function getDate( element ) {
  var date;
  try {
    date = $.datepicker.parseDate( dateFormat, element.value );
  } catch( error ) {
    date = null;
  }
  return date;
}

window.addEventListener("beforeunload", function (e) {
  if($('html').hasClass('editing')) {
    var confirmationMessage = 'It looks like you have been editing something. '
                            + 'If you leave before saving, your changes will be lost.';

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  }
});

function updatePackageDescriptionOnTheRight(elem) {
  package_id = elem.data('package_id');
  braintree_plan_id = elem.data('braintree_plan_id');
  related_braintree_plan_id = elem.data('related_braintree_plan_id');
  if(elem.data('currency') == "RON"){
    $("#package_braintree_ro").val(braintree_plan_id);
    $("#package_braintree_en").val(related_braintree_plan_id);
  }else{
    $("#package_braintree_ro").val(related_braintree_plan_id);
    $("#package_braintree_en").val(braintree_plan_id);
  }
  $('#package_id').val(package_id);
  $(".package-description").addClass('hide');
  $(".package-price").addClass('hide');
  $('#package_description_' + package_id).removeClass('hide');
  $('#package_price_' + package_id).removeClass('hide');
}

function activateButtonsForDailyMeetings() {
  current_step = 1;
  team_id = $('#sidebar_team_id').val();
  
  current_step = parseInt($("#steps_siderbarlist a.active").attr("rel"));      

  $.ajaxSetup({
    header:$('meta[name="_token"]').attr('content')
  });
  $.ajax({
      type: "POST",
      url: '/update_daily_meeting_step',
      dataType: "JSON",
      data: {'step': current_step, 'team_id': team_id},
      success: function(data) {        
        $("#steps_siderbarlist a").each(function( index ) {
          li_step = parseInt($(this).attr('rel'));
          if(li_step < current_step){
            $(this).removeClass('active disabled');
          }
          if(li_step > current_step){
            $(this).removeClass('active').addClass('disabled');
          }
        });
      },
      error: function(data){
      }
  }); 
}

function dailyMeetingTimer() {
  if($(".counter-holder").length > 0) {
    setTimeout(function(){ 
      seconds_holder = $(".counter-holder .seconds");
      minutes_holder = $(".counter-holder .minutes");
      hours_holder = $(".counter-holder .hours");
      var seconds = parseInt(seconds_holder.html()) + 1;
      var minutes = parseInt(minutes_holder.html());
      var hours = parseInt(hours_holder.html());
      
      if(seconds == 60){
        minutes = minutes + 1;
        seconds_holder.html("00");
        seconds_holder.attr("rel",0);
        if(minutes == 60){
          minutes_holder.html("00"); 
          minutes_holder.attr("rel",minutes);
          hours = hours + 1;
          hours_holder.html(hours);
          if(hours < 10){
            hours_holder.html("0"+hours);
          }else{
            hours_holder.html(hours);
          }
          hours_holder.attr("rel",hours);
        }else{
          if(minutes < 10){
            minutes_holder.html("0"+minutes);
          }else{
            minutes_holder.html(minutes);
          }
          minutes_holder.attr("rel",minutes);
        }
      }else{
          if(seconds < 10){
            seconds_holder.html("0"+seconds);
          }else{
            seconds_holder.html(seconds);
          }
          seconds_holder.attr("rel",seconds);
      }
      dailyMeetingTimer();
    }, 1000);
  }
}

function temporaryDisabledModal() {
  if($("#temporary_disabled").length > 0) {
    $("#temporary_disabled").modal('show');
  }
}
function needsToChangeCard() {
  if($("#needs_to_change_card").length > 0) {
    $("#needs_to_change_card").modal('show');
  }  
}

function agreeWithTermsModal() {
  if($("#agree_with_terms").length > 0) {
    $("#agree_with_terms").modal('show');
  }
}

$(document).ready(function()
{   
    agreeWithTermsModal();
    temporaryDisabledModal();
    needsToChangeCard();
    dailyMeetingTimer();

    // POPUP TODO PROCESSES POPUP
    $(document).on('click', "#process-list-in-popup li a", function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      $("#process-list-in-popup li a").removeClass('active');
      $(this).addClass('active');
      $.ajaxSetup({
        header:$('meta[name="_token"]').attr('content')
      });
      $.ajax({
          type: "GET",
          url: href,
          dataType: "JSON",
          success: function(data) {
            $("#process-view-content").html(data.content);
            $("#process-view-title").html(data.title);
            $("#process-download").html('<a target="_blank" class="btn btn-default" href="' + data.download + '">'+ data.text_download +'</a>');
            $("#process-modifications").html('<a target="_blank" class="btn btn-default" href="javascript:void(0);" data-toggle="modal" data-target="' + data.modal_name + '">'+ data.text_process_modifications +'</a>');
            $("#process-penalty").html('<a target="_blank" class="btn btn-default" href="javascript:void(0);" data-toggle="modal" data-target="' + data.modal_penalty + '">'+ data.text_process_penalty +'</a>');
          },
          error: function(data){
          }
      }); 
    });

    // POPUP TODO PROCESSES POPUP TRIGGER CLICK
    $(document).on('click', "#process-view-content a", function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      var process_id = href.split('/')[href.split('/').length - 2];
      $('.search_name_process').val('');
      populateProcessesListInPopupTodo($('.search_name_process'));
      setTimeout(function(){
        $('#sidebar_process_' + process_id).click();
      }, 100);
    });

    // POPUP TODO SOFTWARE POPUP
    $(document).on('click', "#update_notification-in-popup li a", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var href = $(this).attr('href');
      var entity_id = $(this).data('entity_id');
      var current_element = $(this);
      $("#update_notification-in-popup li a").removeClass('active');
      current_element.addClass('active');
      if(current_element.hasClass('new_notification')){
        var popup_update_notification_counter = $("#popup_update_notification_counter").val()-1;
        $("a[rel='software_updates'] .open").html("&nbsp;("+ popup_update_notification_counter +")");
        $("a[rel='software_updates'] .closed").html(popup_update_notification_counter).removeClass('no-info');
        if(popup_update_notification_counter == 0){
          $("a[rel='software_updates'] .open").html('');
          $("a[rel='software_updates'] .closed").html('').addClass('no-info');
        }else{
          $("#popup_update_notification_counter").val(popup_update_notification_counter);
        }
      }

      $.ajax({
          type: "POST",
          url: href,
          dataType: "JSON",
          data: {'id': entity_id},
          success: function(data) {
            current_element.removeClass('new_notification');
            $("#update_notification-view-title").html(data.title);
            $("#update_notification-view-content").html(data.content);
          }
      }); 
    });

    // DAILY MEETING SIDEBAR
    if($("#steps_siderbarlist").length > 0){
      activateButtonsForDailyMeetings();
    }

    // SORT OBJECTIVES
    $( "#sort-objectives" ).sortable({
      update: function (event, ui) {
          var sorted = "";
          // get id of the records in order
          $('.objective-row-content').each(function () {
              if(sorted == ""){
                sorted = $(this).data('id');
              }else{
                sorted = sorted + "," + $(this).data('id');
              }
          });
          $.ajaxSetup({
            header:$('meta[name="_token"]').attr('content')
          });
          $.ajax({
              type: "GET",
              url: '/order_objective_ajax',
              dataType: "HTML",
              data: {'objectives_in_order': sorted},
              success: function(data) {
                console.log(data);
              },
              error: function(data){
              }
          }); 
      }
    });

    $(".sortable-strategic-actions").each(function () {
        $(this).sortable({
            tolerance: 'pointer',
            containment: $(this),
            items: '.strategic-action-row',
            update: function (event, ui) {
              var sorted = "";
              // get id of the records in order
              $('.strategic-action-row').each(function () {
                  if(sorted == ""){
                    sorted = $(this).data('id');
                  }else{
                    sorted = sorted + "," + $(this).data('id');
                  }
              });
              $.ajaxSetup({
                header:$('meta[name="_token"]').attr('content')
              });
              $.ajax({
                  type: "GET",
                  url: '/order_strategic_actions',
                  dataType: "HTML",
                  data: {'strategic_actions_in_order': sorted},
                  success: function(data) {
                    console.log(data);
                  },
                  error: function(data){
                  }
              });
            }
        }).disableSelection();
    });

    $( ".sortable-strategic-actions" ).sortable();

    // Check if form was edited but not saved
    $(".editable-form input, .editable-form select").change(function(){
      $("html").addClass("editing");
    });

    // Check dropdown if can be opened up or down
    $(document).on("click", ".nav-link.dropdown-toggle", function(){
      var element_position = $(this).offset().top;
      var window_height = $(window).height();
      if(window_height - element_position < 290){
        $(this).parent().find('.dropdown-menu').addClass("open-up");
      }else{
        $(this).parent().find('.dropdown-menu').removeClass("open-up");
      }
    });

    // MARK PROCESS AS SEEN OR UNSEEN
    $(document).on('click', ".mark_as_seen", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var current_elem = $(this);
      var entity_id = current_elem.data('entity_id');

      $.ajax({
          type: "POST",
          url: '/mark_process_notification',
          dataType: "JSON",
          data: {'id': entity_id},
          success: function(data) {
            current_elem.addClass('hide');
            current_elem.parent().find('.seen').removeClass('hide');
          }
      }); 
    });

    // MULTIPLE ROLES PICKER FROM DROPDOWN
    $(".choose-roles").click(function(){
      $(this).parent().find(".checklist").toggleClass("show");
    });
    
    $(document).on("click", ".check-roles a", function(){
      $(this).toggleClass('checked');

      var list = '';
      var role_text = '';
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
              role_text += current_elem.html();
            }else{
              list += "," + current_elem.attr('rel');
              role_text += "," + current_elem.html();
            } 
          }
      });
      $("#roles").val(list);
      $(this).parents().find('.choose-roles').html(role_text);
    });

    // MULTIPLE TEAMS PICKER FROM DROPDOWN
    $(document).on("click", ".choose-teams", function(event){
      event.stopPropagation();
      $(this).parent().find(".checklist").toggleClass("show");
      if(!$(this).parent().find(".checklist").hasClass('show')){
        $('#selected_teams_form').submit();
      }
    });
    $(window).click(function(event){
      if(!$(event.target).hasClass('dropdown-item') && $(".filter-holder .checklist").hasClass('show')){
        $('#selected_teams_form').submit();
      }
    });

    $(document).on("click", ".check-teams a", function(){
      $(this).toggleClass('checked');
      var list = '';
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
            }else{
              list += "," + current_elem.attr('rel');
            } 
          }
      });
      $(".teams_selected,#teams").val(list);
      if(list.split(",") == ''){
        var count_selected_teams = '';
        $('.selected_teams').removeClass('hide');
        $('.show_teams').addClass('hide');
      }else{
        var count_selected_teams = list.split(",").length;
        $('.selected_teams').addClass('hide');
        $('.show_teams').removeClass('hide');
      }
      $(this).parents().find('.choose-teams .counter').html(count_selected_teams);
    });

    // check week days dropdown
    $(document).on("click", ".check-week_days a", function(){
      $(this).toggleClass('checked');
      var list = '';
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
            }else{
              list += "," + current_elem.attr('rel');
            } 
          }
      });
      $(".days_selected").val(list);
      if(list.split(",") == ''){
        var count_selected_teams = '';
        $('.selected_days').removeClass('hide');
        $('.show_days').addClass('hide');
      }else{
        var count_selected_teams = list.split(",").length;
        $('.selected_days').addClass('hide');
        $('.show_days').removeClass('hide');
      }
      $(this).parents().find('.choose-week_days .counter').html(count_selected_teams);
    });

    $(".popup_text").click(function(e) {
      e.preventDefault();
      var parent = $(this).closest("li.dropdown");
      var dropdown_item_value = $(this).text();
      parent.children('#dropdown02').text(dropdown_item_value);
      // Only if it has with-ajax class
      if($(this).hasClass('with-ajax')){
        var ajax_href = $(this).data('href');
        var data_target = $(this).attr('href');
        var load_content = $(this).data('load_content');
        if(load_content == true) {
          $.ajaxSetup({
              header:$('meta[name="_token"]').attr('content')
          });
          $.ajax({
            type:"GET",
            url:ajax_href,
            dataType: 'HTML',
            success: function(data)
            {
              $(data_target).append(data);
              $(this).data('load_content',false);
            },
            error: function(data)
            {
              console.log('Something went wrong with the ajax call');    
            }
          });
        }
      }
    });

    // GET TEAM USERS FOR SPECIFIC TEAM
    $(document).on('click', ".show_team_players", function(e){
      e.preventDefault();
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      });
      var team_id = $(this).data("team_id");
      var start_date = $(this).data("start_date");
      var end_date = $(this).data("end_date");

      $.ajax({
        type:"GET",
        url:'/get_team_company_users',
        data: {'team_id': team_id, 'start_date': start_date, 'end_date': end_date},
        dataType: 'HTML',
        success: function(data)
        {
          if($('.team_' + team_id).children().length > 0){
            $('.team_' + team_id).html('');
          }else{
            $('.team_' + team_id).append(data);
          }
        }
      });
    });

    // GET TASKS FOR SPECIFIC TEAM USERS
    $(document).on('click', ".show_team_user_tasks", function(e){
      e.preventDefault();
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      });
      var team_id = $(this).data("team_id");
      var team_user_id = $(this).data("team_user_id");
      var user_id = $(this).data("user_id");
      var start_date = $(this).data("start_date");
      var end_date = $(this).data("end_date");

      $.ajax({
        type:"GET",
        url:'/get_team_user_tasks',
        data: {'team_id': team_id, 'user_id': user_id, 'start_date': start_date, 'end_date': end_date},
        dataType: 'HTML',
        success: function(data)
        {
          if($('.team_user_' + team_user_id).children().length > 0){
            $('.team_user_' + team_user_id).html('');
          }else{
            $('.team_user_' + team_user_id).append(data);
          }
        }
      });
    });

    // Company alerts , dropdown user_teams
    $(document).on('click', "#alert_type,#alert_name,#alert_name_edit,#alert_type_edit", function(e){
      e.preventDefault();
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      });
      if($(this).attr('id') == 'alert_name_edit' || $(this).attr('id') == 'alert_type_edit'){
        var user_id = $('#alert_name_edit').val();
        var alert_type = $('#alert_type_edit').val();
        var company_id = $('#edit_alert_company_id').val();
      }else{
        var user_id = $('#alert_name').val();
        var alert_type = $('#alert_type').val();
        var company_id = $('#alert_company_id').val();
      }

      if(alert_type != '' && user_id != ''){
        $.ajax({
          type:"POST",
          url:'/get_company_user_teams',
          data: {'user_id': user_id, 'company_id': company_id},
          dataType: 'HTML',
          success: function(data)
          {
            $('.company_user_teams').html('').append(data);
            if(alert_type == 'daily_reports'){
              $('.alert_days').removeClass('hide');
              $('.show_days').addClass('hide');
              $('.selected_days').removeClass('hide');
              $('.check-week_days a').removeClass('checked');
              $('.days_selected').val('');
              $('.counter').text('');
            }else{
              $('.alert_days').addClass('hide');
              $('.days_selected').val('');
            }
          },
          error: function(data)
          {
            console.log('Something went wrong with the ajax call');    
          }
        });
      }else{
        $('.company_user_teams').html('');
        $('.alert_days').addClass('hide');
        $('.days_selected').val('');
      }
    });

    // CREATE CRITICAL NUMBER, COMPANY_AMDIN, COMPANY_ALERT, COMPANY_ROLE, COMPANY_DIVISION, TARGET, OBJECTIVE
    $('document').ready(function () {         
      $(document).on('submit', '#entity_form_create', function(e){
        e.preventDefault();
        $.ajaxSetup({
            header:$('meta[name="_token"]').attr('content')
        })
        $(".save-btn").prop('disabled', true);
        var ajax_url = $(this).data('url_ajax');
        var holder = "#" + $(this).attr('id');
        $(holder + ' .btn-primary').addClass('disabled');

      if (ajax_url == "create_objective_ajax"){
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:new FormData($(this)[0]),
          dataType: 'HTML',
          processData:false,
          contentType: false,
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            location.reload();
          },
          error: function(data){
            $(".save-btn").prop('disabled', false);
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }else if(ajax_url == "create_team_ajax"){
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:$(this).serialize(),
          dataType: 'JSON',
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            window.location = data;
          },
          error: function(data){
            $(".save-btn").prop('disabled', false);
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }else{
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:$(this).serialize(),
          dataType: 'HTML',
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            location.reload();
          },
          error: function(data){
            $(".save-btn").prop('disabled', false);
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }
      });
    });

    // UPDATE CRITICAL NUMBER, COMPANY_AMDIN, COMPANY_ALERT, TARGET, OBJECTIVE
    $('document').ready(function () {         
      $(document).on('submit', '#entity_form_edit', function(e){
        e.preventDefault();
        $.ajaxSetup({
            header:$('meta[name="_token"]').attr('content')
        })
        $(".save-btn").prop('disabled', true);
        var ajax_url = $(this).data('url_ajax');
        var holder = "#" + $(this).attr('id');
        $(holder + ' .btn-primary').addClass('disabled');

        if (ajax_url == "edit_objective_ajax"){
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:new FormData($(this)[0]),
          dataType: 'HTML',
          processData:false,
          contentType: false,
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            var base_url = location.href.split('#');
            location.href = base_url[0] + "#objective_row_"+$('#entity_form_edit #objective_id').val();
          },
          error: function(data){
            $(".save-btn").prop('disabled', false);
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }else{
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:$(this).serialize(),
          dataType: 'HTML',
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            location.reload();
          },
          error: function(data){
            $(".save-btn").prop('disabled', false);
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }
      });
    });

    // Submit agree with terms modal
    $(document).on('submit', '#agree_with_terms_form', function(e){
      e.preventDefault();
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      })
      $(".save-btn").prop('disabled', true);
      var ajax_url = $(this).data('url_ajax');
      var holder = "#" + $(this).attr('id');
      $(holder + ' .btn-primary').addClass('disabled');

      $.ajax({
        type:"POST",
        url:"/" + ajax_url,
        data:$(this).serialize(),
        dataType: 'HTML',
        success: function(data){
          $(holder + ' .alert').remove();
          $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
          $(holder + " .alert").append(data.responseText);

          $(holder + " input[type='text']").val('');
          $(holder + ' .btn-primary').removeClass('disabled');

          $(holder + ' .alert').remove();
          $(holder).closest('.modal').modal('hide');
          location.reload();
        },
        error: function(data){
          $(".save-btn").prop('disabled', false);
          var returnedData = JSON.parse(data.responseText);
          $(holder + ' .mesage_form_package').remove();
              $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
              $(holder + ' .btn-primary').removeClass('disabled');
          
          $.each(returnedData, function( index, value ) {
                $(holder + " .mesage_form_package").append(value + "<br>");
          });         
        }
      });
    });

    // SEND CLIENT ERROR
    $(document).on('submit', '#client_error_form', function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      $("#save-btn-error-form").prop('disabled', true).addClass('hide');
      $(".loading-btn").prop('disabled', true).removeClass('hide');
      var ajax_url = $(this).data('url_ajax');
      var holder = "#" + $(this).attr('id');
      $(holder + ' .btn-primary').addClass('disabled');

      if($(this).data('error_page') == 1){
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:new FormData($(this)[0]),
          dataType: 'HTML',
          processData:false,
          contentType: false,
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            location.href = "/";
          },
          error: function(data){
            $("#save-btn-error-form").prop('disabled', false).removeClass('hide');
            $(".loading-btn").addClass('hide');
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }else{
        $.ajax({
          type:"POST",
          url:"/" + ajax_url,
          data:new FormData($(this)[0]),
          dataType: 'HTML',
          processData:false,
          contentType: false,
          success: function(data){
            $(holder + ' .alert').remove();
            $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
            $(holder + " .alert").append(data.responseText);

            $(holder + " input[type='text']").val('');
            $(holder + ' .btn-primary').removeClass('disabled');

            $(holder + ' .alert').remove();
            $(holder).closest('.modal').modal('hide');
            location.reload();
          },
          error: function(data){
            $("#save-btn-error-form").prop('disabled', false).removeClass('hide');
            $(".loading-btn").addClass('hide');
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
                $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
                $(holder + ' .btn-primary').removeClass('disabled');
            
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "<br>");
            });         
          }
        });
      }
    });

    // TRASH IDEA
    $(document).on('click', ".trash_idea", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var current_element = $(this);
      var entity_id = current_element.data('entity_id');

      $.ajax({
          type: "POST",
          url: '/trash_idea',
          dataType: "JSON",
          data: {'id': entity_id},
          success: function(data) {
            current_element.parent().addClass('hide');
          }
      }); 
    });

    // SHOW PACKAGES DROPDOWN
    $(document).on("click", "#free_account-field", function() {
      if($('#free_account-field').is(":checked")){
        $('.hide_package').addClass('hide');
        $('#package_id').val('');
      }else{
        $('.hide_package').removeClass('hide');
      }
    });

    // SHOW REGISTER LEGAL PERSON
    $(document).on("click", "#legal_person", function() {
      $('.hide_individual_form').addClass('hide');
      $('.hide_individual_form input').val('');
      $('.hide_legal_form').removeClass('hide');
      if($('#country').val() == 'RO'){
        $(".reg_hide_legal_form").removeClass('hide');
      }
    });

    // SHOW REGISTER INDIVIDUAL PERSON WHEN ERRORS OCCURS
    $('document').ready(function () {
      if($('#individual_person').is(":checked")){
        $('.hide_legal_form').addClass('hide');
        $('.hide_legal_form input').val('');
        $('.hide_individual_form').removeClass('hide');
        $(".reg_hide_legal_form").addClass('hide');
      }else if($('#legal_person').is(":checked")){
        $('.hide_individual_form').addClass('hide');
        $('.hide_individual_form input').val('');
        $('.hide_legal_form').removeClass('hide');
        if($('#country').val() == 'RO'){
          $(".reg_hide_legal_form").removeClass('hide');
        }
      }
    });

    // SHOW REGISTER INDIVIDUAL PERSON
    $(document).on("click", "#individual_person", function() {
      $('.hide_legal_form').addClass('hide');
      $('.hide_legal_form input').val('');
      $('.hide_individual_form').removeClass('hide');
      $(".reg_hide_legal_form").addClass('hide');
    });

    // SHOW COMPANY ADMIN DIVISION OR TEAM FIELDS

    $(document).on("change", "#admin_type-field,#admin_type-field-edit", function() {
      var val = $(this).val();
      if(val == 'division_admin'){
        $('.division_field').removeClass('hide');
        $('.team_field').addClass('hide');
        $('#team-field,#team-field-edit').val('');
      }else if(val == 'team_admin'){
        $('.team_field').removeClass('hide');
        $('.division_field').addClass('hide');
        $('#division-field,#division-field-edit').val('');
      }else{
        $('.team_field,.division_field').addClass('hide');
        $('#team-field,#team-field-edit').val('');
        $('#division-field,#division-field-edit').val('');
      }
    });

    // MULTIPLE CRITICAL NUMBERS PICKER FROM DROPDOWN
    $(".choose-critical_number").click(function(){
      $(this).parent().find(".checklist").toggleClass("show");
    });
    
    $(document).on("click", ".check-critical_number a", function(){
      $(this).toggleClass('checked');

      var list = '';
      var critical_number_text = '';
      var initial_text = $('#select_critical_number_text').val();
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
              critical_number_text += current_elem.html();
            }else{
              list += "," + current_elem.attr('rel');
              critical_number_text += "," + current_elem.html();
            } 
          }
      });
      $("#team_critical_numbers_select").val(list);
      if(critical_number_text.length > 0){
        $(this).parents().find('.choose-critical_number').html(critical_number_text);
      }else{
        $(this).parents().find('.choose-critical_number').html(initial_text);
      }
    });
    
    // HIDE DROPDOWN FROM CRITICAL NUMBERS 
    $(document).mouseup(function(e){
      if($("#dropdown_multiple_cn").hasClass("show")){
        var subject = $("#dropdown_multiple_cn");
        if(e.target.id != subject.attr('id') && !subject.has(e.target).length){
          $("#dropdown_multiple_cn").removeClass("show");
        }
      }
    });

    // $(document).on("click", "#team_critical_numbers_select", function() {
    //   var selected_value = $(this).val();
    //   if(selected_value.length > 0){
    //     $('.all_critical_numbers').addClass('hide');
    //     $('.all_critical_numbers.'+selected_value).removeClass('hide');
    //   }else{
    //     $('.all_critical_numbers').removeClass('hide');
    //   }
    // });
    
    // SHOW VALUES FROM DROPDOWN ON STEP 6
    $(".step_6-dropdown-holder .dropdown-item").click(function(){
      var href = $(this).attr('href');
      $(".toggle-list").addClass('hide');
      $(href).removeClass('hide');
    });

    // ADD or DELETE USER CATEGORY ACCESS 
    $(document).on("change", ".checkbox_for_users", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if($(this).is(":checked")) {
        var message_checked = "checked";
      }
      var company_user_id = $(this).data('company_user_id');
      var category_id = $(this).data('category_id');
      var company_id = $(this).data('company_id');

      $.ajax({
          type: "POST",
          url: '/update_category_user',
          dataType: "JSON",
          data: {'company_user_id': company_user_id, 'category_id': category_id, 'message_checked': message_checked, 'company_id': company_id},
          success: function(data) {
            if(data == true){
              $("#check_all_" + company_id).prop('checked',true);
            }else{
              $("#check_all_" + company_id).prop('checked',false);
            }
          }
      }); 
    });

    // CHECK ALL, UNCHECK ALL USER CATEGORY ACCESS 
    $(document).on("change", ".check_all", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });

      var company_user_ids = $(this).data('company_user_ids');
      var category_id = $(this).data('category_id');
      var company_id = $(this).data('company_id');

      $.ajax({
          type: "POST",
          url: '/check_all_category_user',
          dataType: "JSON",
          data: {'company_user_ids': company_user_ids, 'category_id': category_id, 'company_id': company_id},
          success: function(data) {
            location.reload();
          }
      }); 
    });

    // ADD or DELETE COMPANY USER ROLE 
    $(document).on("change", ".checkbox_for_roles", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if($(this).is(":checked")) {
        var message_checked = "checked";
      }
      var role_id = $(this).data('role_id');
      var user_id = $(this).data('user_id');
      var company_id = $(this).data('company_id');

      $.ajax({
          type: "POST",
          url: '/update_company_user_role',
          dataType: "JSON",
          data: {'role_id': role_id, 'user_id': user_id, 'company_id': company_id, 'message_checked': message_checked},
          success: function(data) {
          }
      }); 
    });

    // ACCOUNT ALERT SEETINGS
    $(document).on("change", ".checkbox_for_meeting_notification", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if($(this).is(":checked")) {
        var message_checked = "checked";
      }
      var team_id = $(this).data('team_id');
      var alert_type = $(this).data('info');

      $.ajax({
          type: "POST",
          url: '/update_account_alerts',
          dataType: "JSON",
          data: {'team_id': team_id, 'message_checked': message_checked, 'alert_type': alert_type},
          success: function(data) {
          }
      }); 
    });

    // CHANGE USER LANGUAGE
    $(document).on("click", ".change_language", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var language = $(this).attr('rel');

      $.ajax({
          type: "POST",
          url: '/update_language',
          dataType: "JSON",
          data: {'language': language},
          success: function(data) {
            location.reload();
          }
      }); 
    });

    // SEARCH PROCESS
    $(document).on("keyup", ".search_name_process, .search_name_strategic_action", function() {
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      populateProcessesListInPopupTodo($(this)); 
    });

    // UPDATE INSTANCE PARTNER NAME
    $(document).on("change", ".update_instance_partner", function() {
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var partner_id = $(this).val();
      var instance_id = $(this).data('instance_id');
      $.ajax({
          type: "POST",
          url: "/update_instance_partner",
          dataType: "JSON",
          data: {'partner_id': partner_id, 'instance_id': instance_id},
          success: function(data) {
          }
      }); 
    });

    // MAKE CHECK-BOXES FOR TEAM PLAYERS AS RADIO BUTTONS
    $(document).on('click', '.checkbox_captain', function(){
      $('.checkbox_captain').each(function(){
          $(this).prop('checked', false); 
      }); 
      $(this).prop('checked', true);
    });

    // UPDATE WITH CHECK-BOXES TEAM PLAYERS 
    $(document).on("change", ".checkbox_entity", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var entity_id = $(this).data('entity_id');
      var entity_type = $(this).data('entity_type');
      var url_ajax = $(this).data('url_ajax');
      var this_checked = $(this).is(":checked");
      if($(this).hasClass('checkbox_captain') && this_checked){
        $('.checkbox_captain').prop('checked',false);
        $('.checkbox_observer').prop('disabled',false);
        $('.checkbox-box').removeClass('disabled');
        
        $(this).closest('.player-row').find('.checkbox_observer').attr('disabled',true);
        $(this).closest('.player-row').find('.checkbox_observer').parent().addClass('disabled');
        $(this).closest('.player-row').find('.checkbox_observer').prop('checked',false);
        
        $(this).prop('checked',true);
      }

      if($(this).hasClass('checkbox_observer') && this_checked){
        $(this).closest('.player-row').find('.checkbox_captain').prop('checked',false);
        $(this).prop('checked',true);
      }
      $.ajax({
          type: "POST",
          url: "/" + url_ajax,
          dataType: "JSON",
          data: {'id': entity_id, 'entity_type': entity_type, 'checked': this_checked},
          success: function(data) {
          }
      }); 
    });

    // ADD NEW TEAM PLAYER
    $('#players_field').selectize({
      onChange: function(value) {
        if(value != '') {
          $.ajaxSetup({
              headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
              }
          });
          $.ajax({
              type: "POST",
              url: '/add_team_player',
              dataType: "HTML",
              data: {'team_id': $("#team_id").val(), 'user_id': value},
              success: function(data) {
                  $("#players-list").append(data);
                  $('#players_field')[0].selectize.clear();
              },
              error: function(data){
                  $('#players_field')[0].selectize.clear();
              }
          });
        }
      } 
    });
    // --------------------------------------
    // --------------------------------------
    // Update percentage on strategic actions
    // send params: id, percentage, update_url
    // --------------------------------------
    // --------------------------------------
    $(document).on("click", ".choose-progress-from-dropdown .dropdown-item", function(e) {
        $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
        e.preventDefault();
        
        var parent = $(this).closest("li.dropdown");
        var dropdown_item_value = $(this).text();
        var progress_bar = $(this).parents('.choose-progress-from-dropdown').find('.bar');
        var current_elem = $(this);
        $('#percentage_log_data').val(current_elem.data('percentage'));
        if (current_elem.data('info') == 'week_plan'){
          $('#week_plan_id').val(current_elem.data('id'));
        }else{
          $('#strategic_action_id').val(current_elem.data('id'));
          var base_url = location.href.split("#")[0];
          return_url = base_url+"#strategic-action-row-"+current_elem.data('id');
          $("#return_url").val(return_url);
        }
        $('#percentage_log').modal('show');
        $('#ajax_form_add_percentage_log').on('submit',function() {
          $.ajax({
              type: "POST",
              url: current_elem.data('update_url'),
              dataType: "JSON",
              data: {'id': current_elem.data('id'), 'percentage': current_elem.data('percentage'), 'return_url': return_url},
              success: function(data) {
                  parent.children('#dropdown01').text(dropdown_item_value);
                  progress_bar.css('width', dropdown_item_value);
                  if(dropdown_item_value == "100%"){
                      progress_bar.addClass('full');
                      progress_bar.closest('.list-row').addClass("line-through");
                  }else{
                      progress_bar.removeClass('full');
                      progress_bar.closest('.list-row').removeClass("line-through");
                  }
              }
          });
        });
    });
    // --------------------------------------
    // --------------------------------------
    // END: Update percentage
    // --------------------------------------
    // --------------------------------------

    // --------------------------------------
    // --------------------------------------
    // Update record inline
    // Send params through data attributes: id, update_url
    // --------------------------------------
    // --------------------------------------
    $(document).on("focus", ".update-record", function() {
        $(this).parent().parent().find(".delete-holder").removeClass('hide');
        $(this).parent().parent().find(".choose-progress-from-dropdown").addClass('hide'); 
    });
    $(document).on("blur", ".update-record", function(e) {
        $(this).parent().parent().find(".delete-holder").addClass('hide');
        $(this).parent().parent().find(".choose-progress-from-dropdown").removeClass('hide'); 
        e.preventDefault();
        updateRecordInline($(this)); 
    });
    $(document).on("keypress", ".update-record", function(e) {
        var code = e.keyCode || e.which;
        if(code == 13) 
        {
            $(this).parent().parent().find(".delete-holder").addClass('hide');
            $(this).parent().parent().find(".choose-progress-from-dropdown").removeClass('hide'); 
            updateRecordInline($(this));
        };
    });
    // --------------------------------------
    // --------------------------------------
    // END: Update record inline
    // --------------------------------------
    // --------------------------------------

    // --------------------------------------
    // --------------------------------------
    // delete record inline
    // Send params through data attributes: id, route
    // --------------------------------------
    // --------------------------------------
    $(document).on("mousedown", ".remove-record", function(e){
        e.preventDefault();
        var id = $(this).data('id');
        console.log(id);
        $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
        $.ajax({
            type: "DELETE",
            url: $(this).data('route'),
            dataType: "HTML",
            data: {'id': id},
            success: function(data) {
                $(".row[data-id='"+ id +"']").remove();
            }
        }); 
      });
    // --------------------------------------
    // --------------------------------------
    // END: Delete record inline
    // --------------------------------------
    // --------------------------------------

    // INVOICES FILTER
    var dateFormat = "yy-mm-dd";
    invoice_start_date = $( "#invoice_start_date" )
      .datepicker({
        dateFormat: dateFormat,
        defaultDate: "+1d",
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1
      })
      .on( "change", function() {
        invoice_end_date.datepicker( "option", "minDate", getDate( this ) );
      }),
    invoice_end_date = $( "#invoice_end_date" ).datepicker({
      dateFormat: dateFormat, 
      defaultDate: "+1d",
      changeMonth: true,
      changeYear: true,
      numberOfMonths: 1
    })
    .on( "change", function() {
      invoice_start_date.datepicker( "option", "maxDate", getDate( this ) );
    });

  // Show team critical number if progress type selected value is critical numbers
  $(document).on("change",'#progress_type-field, #progress_type-field-edit',function (){
    val = $(this).val();
    if(val == 'critical_numbers'){
      $('#critical_number-field, #critical_number-field-edit').parent().removeClass('hide');
      $('#target_value-field, #target_value-field-edit').parent().removeClass('hide');
    }else{
      $('#critical_number-field, #critical_number-field-edit').parent().addClass('hide');
      $('#target_value-field, #target_value-field-edit').parent().addClass('hide');
    }
  });

  // Show company division after company selection
  $(document).on("change",'#company_id',function (e){
    e.preventDefault();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    var company_id = $(this).val();

    if(company_id.length > 0){
      $.ajax({
          type: "POST",
          url: "/get_divisions_object",
          dataType: "HTML",
          data: {'company_id': company_id},
          success: function(data) {
            $(".company_divisions_dropdown").html(data);
            $('#division_id').parent().removeClass('hide');
          }
      });
    }else{
      $('#division_id').parent().addClass('hide');
      $(".company_divisions_dropdown").html('');
    }
  });

  // TARGET -> START_DATE, END_DATE
  $(document).on("focus",'.datepicker',function (){
    if($(this).hasClass('start_date')){
      start = $('.start_date');
      end = $('.end_date');
    }else if($(this).hasClass('start_date_edit')){
      start = $('.start_date_edit');
      end = $('.end_date_edit');
    }else if($(this).hasClass('end_date')){
      end = $('.end_date');
      start = $('.start_date');
    }else if($(this).hasClass('end_date_edit')){
      end = $('.end_date_edit');
      start = $('.start_date_edit');
    }
    var dateFormat = "yy-mm-dd";
    start_date = start.datepicker({
        dateFormat: dateFormat,
        defaultDate: "+1d",
        minDate: 0,
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1
      })
      .on( "change", function() {
        end_date.val('');
        end_date.datepicker( "option", "minDate", start_date.val() );
      }),
    end_date = end.datepicker({
      dateFormat: dateFormat, 
      defaultDate: "+1d",
      changeMonth: true,
      changeYear: true,
      numberOfMonths: 1
    })
    .on( "change", function() {
      if (start_date.val() > end_date.val()){
        end_date.val('');
      }
    });
  });

    // POPUP NOTIFICATION BOX
    if($("#popup_notification_counter").length > 0 && $("#popup_notification_counter").val() != "0"){
      $("a.triggers").removeClass("active");
      $("#planning_day").removeClass("active");
      $("a[rel='notifications']").addClass("active");
      $("a[rel='notifications'] .open").html("&nbsp;("+$("#popup_notification_counter").val()+")");
      $("a[rel='notifications'] .closed").html($("#popup_notification_counter").val());
      $("#notifications").addClass("active");
    }else{
      $("a[rel='notifications']").addClass("hide");
    }

    // POPUP UPDATE NOTIFICATION BOX
    if($("#popup_update_notification_counter").length > 0 && $("#popup_update_notification_counter").val() != "0"){
      $("a[rel='software_updates'] .open").html("&nbsp;("+$("#popup_update_notification_counter").val()+")");
      $("a[rel='software_updates'] .closed").html($("#popup_update_notification_counter").val());
    }else{
      if($("#popup_update_notification_counter").length > 0){
        $("a[rel='software_updates'] .closed").addClass('no-info');
      }
    }

    // POPUP TASKS BOX
    if($("#popup_tasks_counter").length > 0 && $("#popup_tasks_counter").val() != "0"){
      updatePopUpHeader();
    }

    // SELECT PACKAGE
    $('#country').change(function(e) {
      e.preventDefault();
      $("#cui").val('');
      if($(this).val() == 'RO'){
        if($('#legal_person').is(":checked")){
          $('.cui-holder').addClass('one-of-two');
          $('.reg_number').removeClass('hide');
          $('.ro').removeClass('hide');
          $('.all').addClass('hide');
        }
      }else{
        $('.reg_number').addClass('hide');
        $('.cui-holder').removeClass('one-of-two');
        $('.ro').addClass('hide');
        $('.all').removeClass('hide');
      }
      $(".cui-message").addClass('hide');
      updatePriceDescription(false);
    });

    // CLOSE OBJECTIVE
    $(document).on("click", ".close_objective_and_prize", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var id = $(this).data('entity_id');
      var ajax_url = $(this).data('url_ajax');
      var popup_id = $(this).data('popup_id');

      $.ajax({
          type: "POST",
          url: "/" + ajax_url,
          dataType: "HTML",
          data: {'id': id},
          success: function(data) {
            if($("#edit_objective").length > 0){
              $("#edit_objective").modal('hide');
              $(".edit-modal-holder").html('');
            }
            $(".close-objective-modal-holder").html(data);
            $(popup_id).modal('show');
          }
      }); 
    });

    // Make green color the label when check options in modal
    $(document).on("change", ".checkbox-box input", function(e) {
      if($(this).is(":checked")) {
        var message_checked = "checked";
            $(this).parent().parent().addClass('checked-box-with-label');
      }else{
        $(this).parent().parent().removeClass('checked-box-with-label');
      }
    });

    // go-to-new-objective
    $(".go-to-new-objective").click(function(){
      var alert_holder = $("#choose-company-for-new-objective").parent().parent().find(".alert");
      alert_holder.addClass('hide');
      var company_id = $("#choose-company-for-new-objective").val();
      if(company_id != ""){
        alert_holder.addClass('hide');
        location.href = "/objectives/create?company_id="+company_id;
      }else{
        alert_holder.removeClass('hide');
      }
    });

    // change company
    $("#company_id-field").change(function(){
      var company_id = $(this).val();
      $(".select-users-for-certain-company").addClass('hide');
      $(".select-users-for-certain-company").prop('disabled', true);
      $("#employees-for-company-"+company_id).removeClass('hide');
      $("#employees-for-company-"+company_id).prop('disabled', false);
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      $.ajax({
          type: "POST",
          url: '/objectives/update_company_on_objective',
          dataType: "JSON",
          data: {'company_id': company_id, id: $("#company_id-field").attr('rel')},
          success: function(data) {
          }
      });
    });
    
    var language = $('html').attr('lang');
    $.datepicker.setDefaults($.datepicker.regional[language]);


    $(document).on('click', ".task-name", function(){
      $(this).addClass('hide');
      $(this).parent().children('input').addClass('show');
    });
    $(document).on("blur", ".custom-promise-row .update-record", function(e) {
      $(this).removeClass('show');
      var task_name_holder = $(this).parent().children('.task-name');
      // task_name_holder.html($(this).val()+"<span>" + task_name_holder.find("span").html() + "</span>");
      task_name_holder.removeClass('hide');
    });

    $(document).on("click", ".remove-personal-task", function(e){
      e.preventDefault();
      var task_id = $(this).data('task_id');

      $.ajax({
          type: "DELETE",
          url: '/remove_task',
          dataType: "JSON",
          data: {'id': task_id},
          success: function(data) {
              $(".checkbox_parent[data-task_id='"+ task_id +"']").remove();
              updatePopUpHeader();
          }
      }); 
    });

    $(document).on("click", ".remove-meeting-task", function(e){
      e.preventDefault();
      var task_id = $(this).data('task_id');

      $.ajax({
          type: "DELETE",
          url: '/remove_meeting_task',
          dataType: "JSON",
          data: {'id': task_id},
          success: function(data) {
              $(".checkbox_parent[data-task_id='"+ task_id +"']").remove();
          }
      }); 
    });


    // EDIT DATA THROUGH POPUP
    $(document).on("click", ".edit-with-popup", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var id = $(this).data('entity_id');
      var ajax_url = $(this).data('url_ajax');
      var popup_id = $(this).data('popup_id');
      var user_id = $(this).data('user_id');
      if(!$(this).hasClass('waiting'))
      {
        $(this).addClass('waiting'); 
        $.ajax({
            type: "POST",
            url: "/" + ajax_url,
            dataType: "HTML",
            data: {'id': id, 'user_id': user_id},
            success: function(data) {
              $('.edit-with-popup').removeClass('waiting'); 
              $(".edit-modal-holder").html(data);
              $(popup_id).modal('show');
            }
        }); 
      }
    });

    // GET TEAM OBJECT FROM SELECT (Repeated Task)
    $(document).on("change", "#team_id-field, #team_id-field-edit", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var id = $(this).val();
      if(id != ""){
        $.ajax({
            type: "POST",
            url: "/get_team_object",
            dataType: "HTML",
            data: {'id': id},
            success: function(data) {
              $(".user_target_days").html(data);
            }
        }); 
      }else{
        $(".user_target_days").html('');
      }
    });

    // ADD NEW TASK FROM POPUP
    $('.add_new_task').keypress(function(e){
      var code = e.keyCode || e.which;
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if(code == 13 && $(this).val().length > 0){      
        var rel = $(this).attr('rel');
        var user_id = $(this).data('user_id');
        var team_id = $(this).data('team_id');

        $.ajax({
            type: "POST",
            url: "/set_task_popup",
            dataType: "HTML",
            data: {'team_id': team_id, 'company_id': $(this).data('company_id'), 'name': $(this).val(), 'user_id': user_id, 'type': rel},
            success: function(data) {
              var input_add_new_record = "[data-user_id='"+ user_id +"']";
                if(rel == 'promise'){
                  $("#promise_list-" + team_id).append(data);
                  $(".promise" + input_add_new_record).hide();
                  $(".classic" + input_add_new_record).show();
              }else{
                  $("#classic_list-" + team_id).append(data);
              }
                $(".add_new_task").val('');
                updatePopUpHeader();
            }
        }); 
      };
    });

    // DELETE DIVISION, PROCESS, ADMIN, ALERT, PLAYER
    $(document).on("click", ".delete-entity", function(e){
      e.stopPropagation();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var id = $(this).data('entity_id');
      var ajax_url = $(this).data('url_ajax');
      var form = $(this).parents().closest('.remove_entity');

      $.ajax({
          type: "DELETE",
          url: "/" + ajax_url,
          dataType: "JSON",
          data: {'id': id},
          success: function(data) {
            form.hide();
          }
      }); 
    });

    $(document).on("click", ".remove_entity_data", function(e){
        e.stopPropagation();
        var entityId = $(this).data('entity_id');
        var entityType   = $(this).data('entity_type');
        var companyId   = $(this).data('company_id');
        if($("#edit_objective").length > 0){
          $("#edit_objective").modal('hide');
        }
        generateDeleteEntityModal(entityType, entityId, companyId);
    });

    /**
     * Handles ajax call to generate delete entity modal with checkboxes
     */
    function generateDeleteEntityModal($entityType, $entityId, companyId)
    {
        str = "";
        if(companyId != ""){
          str = "?company_id="+companyId;
        }
        $('body').find('.delete_entity_modal').remove();
        $.ajax({
          type:"GET",
          url:'/delete_entity/' + $entityId + '/' + $entityType + str,
          dataType: 'HTML',
          success: function(data)
          {
              $('body').append(data);
              $('.delete_entity_modal').modal();

              $('#ajax_form_delete_entity').on('submit',function(e)
              {
                  // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
                  $.ajaxSetup({
                      header:$('meta[name="_token"]').attr('content')
                  })
                  e.preventDefault();
                  // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
                  var holder = "#" + $(this).attr('id');
                
                  // Butonul de submit al form-ului se pune pe disable pentru ca userul
                  // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
                  $(holder + ' .btn-primary').addClass('disabled');
                  $.ajax({
                    type:"POST",
                    // Se adauga manual ruta setata la PASUL 4
                    url:'/delete_entity_data',
                    data:$(this).serialize(),
                    dataType: 'json',
                    success: function(data){
                       if(data.status == true)
                       {
                          var deleteLocation = $('.delete_entity_modal').find('#remove_location').val();

                          $(deleteLocation + '[data-entity_id="' + $entityId + '"]').remove();

                          $('.delete_entity_modal').modal('hide');
                          if($entityType == 'team_player'){
                            location.reload();
                          }
                          location.reload();
                       }
                    },
                    error: function(data)
                    {
                    }
                  });
              });
          },
          error: function(data)
          {
            console.log('Something went wrong with the ajax call');    
          }
        });
    }

    $(document).on("change", ".checkbox_parent .checkbox_for_popup", function(e) {
      e.preventDefault();

      if($(this).is(":checked")) {
        var message_checked = "checked";
        $(this).parent().parent().addClass('checked');
        $(this).parent().parent().parent().addClass('checked');
      }else{
        $(this).parent().parent().removeClass('checked');
        $(this).parent().parent().parent().removeClass('checked');
      }
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      $.ajax({
          type: "POST",
          url: '/update_task_date',
          dataType: "JSON",
          data: {'id': $(this).data('id'),'message_checked': message_checked},
          success: function(data) {
            updatePopUpHeader();
          }
      }); 
    });

  // General daterange picker
  var initialDateRange = false;
  $('#general-daterange').daterangepicker({
      initialText : $('#general-daterange').attr('data-placeholder'),
      applyOnMenuSelect: false,
      presetRanges: [],
      datepickerOptions : {
         numberOfMonths : 3
      },
      change: function(event, data) {
        var newParams = jQuery.parseJSON($('#general-daterange').val());
        var newUrl = "?start_range=" + newParams['start'] + "&end_range=" + newParams['end'];
        if(initialDateRange == true)
        {
          document.location.href = window.location.href.split("?")[0] + newUrl;
        }
      },
  });

  var startDate = moment($('#general-daterange').attr('data-start')).toDate();
  var endDate = moment($('#general-daterange').attr('data-end')).toDate();
      
  $("#general-daterange").daterangepicker("setRange", {
        start: startDate,
        end: endDate,
        numberOfMonths : 3,
        firstDay: 1
  });

  // Ideas daterange picker
  var initialDateRange = false;
  $('#ideas-daterange').daterangepicker({
      initialText : $('#ideas-daterange').attr('data-placeholder'),
      applyOnMenuSelect: false,
      presetRanges: [],
      datepickerOptions : {
         numberOfMonths : 3
      },
      change: function(event, data) {
        var newParams = jQuery.parseJSON($('#ideas-daterange').val());
        $("#start_date").val(newParams['start']);
        $("#end_date").val(newParams['end']);
        if(initialDateRange == true)
        {
          $(this).parent().submit();
        }
      },
  });

  var startDate = moment($('#ideas-daterange').attr('data-start')).toDate();
  var endDate = moment($('#ideas-daterange').attr('data-end')).toDate();
      
  $("#ideas-daterange").daterangepicker("setRange", {
        start: startDate,
        end: endDate,
        numberOfMonths : 3,
        firstDay: 1
  });

  // Reports daterange picker
  var initialDateRange = false;
  $('#reports-daterange').daterangepicker({
      initialText : $('#reports-daterange').attr('data-placeholder'),
      applyOnMenuSelect: false,
      presetRanges: [],
      datepickerOptions : {
         numberOfMonths : 3
      },
      change: function(event, data) {
        var newParams = jQuery.parseJSON($('#reports-daterange').val());
        $("#start_date").val(newParams['start']);
        $("#end_date").val(newParams['end']);
        if(initialDateRange == true)
        {
          $("#selected_teams_form").submit();
        }
      },
  });

  var startDate = moment($('#reports-daterange').attr('data-start')).toDate();
  var endDate = moment($('#reports-daterange').attr('data-end')).toDate();
      
  $("#reports-daterange").daterangepicker("setRange", {
        start: startDate,
        end: endDate,
        numberOfMonths : 3,
        firstDay: 1
  }); 
  // END Reports daterange picker

  initialDateRange = true;

  $(".popup").click(function(e) {
    e.preventDefault();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    var team_id = $(this).data('team_id');
    var user_id = $('#idea_area').data('user_id');
    var idea_name = $('#idea_area').val();
    if(idea_name.length > 0){      
      $.ajax({
            type: "POST",
            url: '/set_popup_idea',
            dataType: "JSON",
            data: {'team_id': team_id, 'user_id': user_id, 'name': idea_name},
            success: function(data) {
              document.getElementById("popup-ideea").reset();
              $('.idea_sent_successfully').fadeIn(); 
              setTimeout(function(){ 
                $('.idea_sent_successfully').fadeOut();
              }, 2000);
            }
        }); 
      };
  });

  $(".add-personal-task").keypress(function(e) {
      var code = e.keyCode || e.which;
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if(code == 13 && $(this).val() != "") 
      {
        $.ajax({
            type: "POST",
            url: '/set_personal_task',
            dataType: "HTML",
            data: {'name': $(this).val(), 'user_id': $(this).data('user_id')},
            success: function(data) {
                $(".personal_popup").append(data);
                $(".add-personal-task").val('');
                updatePopUpHeader();
            }
        }); 
      };
  });

  $(".add-meeting-task").keypress(function(e) {
      var code = e.keyCode || e.which;
      var team_id = $(this).data('team_id');
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      if(code == 13 && $(this).val() != "") 
      {
        $.ajax({
            type: "POST",
            url: '/set_meeting_task',
            dataType: "HTML",
            data: {'name': $(this).val(), 'team_id': team_id},
            success: function(data) {
                $(".personal_popup_" + team_id).append(data);
                $(".add-meeting-task").val('');
            }
        }); 
      };
  });

  $(".close_prize_seen").click(function(e) {
    e.preventDefault();
    var prize_notification = $(this).closest('.prize_seen');
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        type: "POST",
        url: '/set_prize_seen',
        dataType: "JSON",
        data: {'id': $(this).data('id')},
        success: function(data) {
          prize_notification.hide();
        }
    }); 
  });
  
    // TODO MENU
    $(".todo-menu .triggers").click(function(e){
      e.preventDefault();
      var rel = $(this).attr('rel');
      $(".todo-menu li a").removeClass('active');
      $(this).addClass('active');
      $(".containers").removeClass('active');
      $("#"+rel).addClass('active');
    });
    $(".todo-box").click(function(e){
      if((!$(this).hasClass('active')) || e.target.className == "trigger-close-popup" || e.target.className == "icon-minimize"){
        $(".todo-box").toggleClass('active');
        $(".todo-overlay").toggleClass('active');
      }
    });
    // $(".trigger-close-popup").click(function(e){
    //   $(".todo-box").toggleClass('active');
    // });

  	$(document).on('click',".save-btn",function(){
      $('html').removeClass('editing');
  		var rel = $(this).attr("rel");

      if($(this).hasClass('as_draft_btn'))
      {
          $('#as-draft-status').attr('value','true');
      }
  		$(rel).submit();
  	});

    $('#add_critical_number').on('show.bs.modal', function(){
      initObjectiveCriticalNumberForm();
    });

    if($('body').find('#add_prize').length > 0)
    {
        initPrizeForm();
    }

    $(document).on("click", "#team-members-list .row.list-row", function() {
        var entityId = $(this).attr('data-id');
        var entityType = 'team_member';

        generateModal(entityId, entityType);
    });

    $(document).on("click", "#strategic-actions-list .row.list-row", function() {
        var entityId = $(this).attr('data-id');
        var entityType = 'strategic_action';

        generateModal(entityId, entityType);
    });

    $(document).on("click", "#critical-numbers-list .row.list-row", function() {
        var entityId = $(this).attr('data-id');
        var entityType = 'critical_number';

        generateModal(entityId, entityType);
    });

    $(document).on("click", "#prizes-list .row.list-row", function() {
        var entityId = $(this).attr('data-id');
        var entityType = 'prize';

        generateModal(entityId, entityType);
    });

    $('#objective-actions').change(function(e){
        e.preventDefault();

        if($(this).val() == 'close_objective')
        {
          $('#close_objective').modal('show');
        }
        else
        {
            window.location.replace($(this).val());
        }
    })


    // Handles critical number form for objectives
    function initObjectiveCriticalNumberForm()
    {
        var modalId   = '#add_critical_number';
        var initValue = $(modalId + ' #target-type-field').val();

        var targetDays = $('#target_days').val();

        // var selectizeElement = $(modalId + ' .selectize-input');

        // var select = selectizeElement;

        // if(selectizeElement[0].selectize == undefined)
        // {
        //     select = selectizeElement.selectize({
        //         maxItems: 7,
        //     });
        // }
        // else
        // {
        //     select[0].selectize.clear();
        // }

        // var selectedItems = targetDays;
        // selectedItems = selectedItems.split(',');
        // var selectize = select[0].selectize;
        // selectedItems.forEach(function(item) {
        //   selectize.addItem(item);
        // });

        if(initValue == 'min')
        {
            $(modalId + ' #max-value-field').hide();
            $(modalId + ' #min-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(initValue == 'max')
        {
            $(modalId + ' #min-value-field').hide();
            $(modalId + ' #max-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(initValue == 'marja')
        {
            $(modalId + ' #min-value-field').show();
            $(modalId + ' #max-value-field').show(); 
            $(modalId + " .min-max-holder").addClass('input-splitted');
        }


        $(modalId + ' #target-type-field').change(function(){
            var currentValue = $(this).val();

              if(currentValue == 'min')
              {
                  $(modalId + ' #max-value-field').hide();
                  $(modalId + ' #min-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'max')
              {
                  $(modalId + ' #min-value-field').hide();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'marja')
              {
                  $(modalId + ' #min-value-field').show();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").addClass('input-splitted');
              } 
        });
    }

    // Handles prize form for objectives
    function initPrizeForm()
    {
        var modalId = '#add_prize';
        var numarCriticEl = '#critical-number-field';
        var targetTypeEl = '#target-type-field';

        var numarCriticValue    = $(numarCriticEl).val();
        var targetTypeValue     = $(targetTypeEl).val();


        if(numarCriticValue == '')
        {
            $(modalId + ' #without-critical-number').show();
            $(modalId + ' #with-critical-number').hide(); 
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }
        else
        {
            $(modalId + ' #without-critical-number').hide();
            $(modalId + ' #with-critical-number').show(); 
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'min')
        {
            $(modalId + ' #max-value-field').hide();
            $(modalId + ' #min-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'max')
        {
            $(modalId + ' #min-value-field').hide();
            $(modalId + ' #max-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'marja')
        {
            $(modalId + ' #min-value-field').show();
            $(modalId + ' #max-value-field').show(); 
            $(modalId + " .min-max-holder").addClass('input-splitted');
        }

        $(modalId + ' #target-type-field').change(function(){
            var currentValue = $(this).val();

              if(currentValue == 'min')
              {
                  $(modalId + ' #max-value-field').hide();
                  $(modalId + ' #min-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'max')
              {
                  $(modalId + ' #min-value-field').hide();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'marja')
              {
                  $(modalId + ' #min-value-field').show();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").addClass('input-splitted');
              } 
        });

        $(modalId + ' ' + numarCriticEl).change(function(){
            var currentValue = $(this).val();

            if(currentValue == '')
            {
                $(modalId + ' #without-critical-number').show();
                $(modalId + ' #with-critical-number').hide(); 
            }
            else
            {
                $(modalId + ' #without-critical-number').hide();
                $(modalId + ' #with-critical-number').show(); 
            }
        });
    }


    // Generates modal for objectives based on entity type
    function generateModal($entityId, $entityType)
    {
        $('body').find('.team_member_modal_edit').remove();
        $('body').find('.strategic_action_modal_edit').remove();
        $('body').find('.edit_critical_number').remove();
        $('body').find('.prize_modal_edit').remove();

        $.ajax({
          type:"GET",
          url:'/generate_modal/' + $entityId + '/' + $entityType,
          dataType: 'HTML',
          success: function(data)
          {
              $('body').append(data);

              if($entityType == 'team_member')
              {
                  initTeamMemberModal($entityId);
              }

              if($entityType == 'strategic_action')
              {
                  initStrategicActionModal($entityId);
              }

              if($entityType == 'critical_number')
              {
                  initCriticalNumberModal($entityId);
              }

              if($entityType == 'prize')
              {
                  initPrizeModal($entityId);
              }
          },
          error: function(data)
          {
            console.log('Something went wrong with the ajax call');    
          }
        });
    }


    // Initialize team member modal after modal generator
    function initTeamMemberModal($entityId)
    {
        $('.team_member_modal_edit').modal();

        $('#ajax_form_edit_team_member').on('submit',function(e)
        {
            // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
            $.ajaxSetup({
                header:$('meta[name="_token"]').attr('content')
            })
            e.preventDefault(e);
            // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
            var holder = "#" + $(this).attr('id');
          
            // Butonul de submit al form-ului se pune pe disable pentru ca userul
            // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
            $(holder + ' .btn-primary').addClass('disabled');
            $.ajax({
              type:"POST",
              // Se adauga manual ruta setata la PASUL 4
              url:'/add_team_member',
              data:$(this).serialize(),
              dataType: 'HTML',
              success: function(data){
                  // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
                  $(holder + ' .mesage_form_package').remove();

                  var oldTeamMember = $('#team-members-list .row.list-row[data-id="' + $entityId + '"]');
                  oldTeamMember.remove();

                  var firstElement = $('#responsible-field').find('option[value="' + $entityId +'"]').first();
                  firstElement.remove();

                  $('#team-members-list').append(data);                  


                  $(prepend_location).parent().find(".btn-default").addClass("add-margin");
                  $(holder + ' .btn-primary').removeClass('disabled');
                  $(holder).closest('.modal').modal('hide');
                  $(holder + " input[type='text']").val('');

                  var lastTeamMember = $('#team-members-list .list-row').last();
            
                  $('#responsible-field').append($("<option></option>")
                    .attr("value",lastTeamMember.attr('data-id'))
                    .text(lastTeamMember.attr('data-email')));
                  },
              error: function(data){
                  var returnedData = JSON.parse(data.responseText);
      $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          $(holder + " .mesage_form_package").append(returnedData["email"]);
          $(holder + ' .btn-primary').removeClass('disabled');
              }
            });
        });
    }

    // Initialize strategic action modal
    function initStrategicActionModal($entityId)
    {
        $('.strategic_action_modal_edit').modal();

        $('#ajax_form_edit_strategic_action').on('submit',function(e)
        {
            // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
            $.ajaxSetup({
                header:$('meta[name="_token"]').attr('content')
            })
            e.preventDefault(e);
            // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
            var holder = "#" + $(this).attr('id');
          
            // Butonul de submit al form-ului se pune pe disable pentru ca userul
            // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
            $(holder + ' .btn-primary').addClass('disabled');
            $.ajax({
              type:"POST",
              // Se adauga manual ruta setata la PASUL 4
              url:'/add_strategic_action',
              data:$(this).serialize(),
              dataType: 'HTML',
              success: function(data){
                  // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
                  $(holder + ' .mesage_form_package').remove();

                  var oldStrategicAction = $('#strategic-actions-list .row.list-row[data-id="' + $entityId + '"]');
                  oldStrategicAction.remove();

                  $('#strategic-actions-list').append(data);                  


                  $(prepend_location).parent().find(".btn-default").addClass("add-margin");
                  $(holder + ' .btn-primary').removeClass('disabled');
                  $(holder).closest('.modal').modal('hide');
                  $(holder + " input[type='text']").val('');
              },
              error: function(data){
                var returnedData = JSON.parse(data.responseText);
      $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          $(holder + " .mesage_form_package").append(returnedData["email"]);
          $(holder + ' .btn-primary').removeClass('disabled');
              }
            });
        });
    }

    // Initialize critical number modal
    function initCriticalNumberModal($entityId)
    {
        var modalId   = '.critical_number_modal_edit';
        var initValue = $(modalId + ' #target-type-field').val();

        var select = $(modalId + ' .selectize-input').selectize({
            maxItems: 7,
        });

        // var selectedItems = select.attr('data-value');
        // selectedItems = selectedItems.split(',');

        // var selectize = select[0].selectize;

        // selectedItems.forEach(function(item) {
        //   selectize.addItem(item);
        // });



        if(initValue == 'min')
        {
            $(modalId + ' #max-value-field').hide();
            $(modalId + ' #min-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(initValue == 'max')
        {
            $(modalId + ' #min-value-field').hide();
            $(modalId + ' #max-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(initValue == 'marja')
        {
            $(modalId + ' #min-value-field').show();
            $(modalId + ' #max-value-field').show(); 
            $(modalId + " .min-max-holder").addClass('input-splitted');
        }


        $(modalId + ' #target-type-field').change(function(){
            var currentValue = $(this).val();

              if(currentValue == 'min')
              {
                  $(modalId + ' #max-value-field').hide();
                  $(modalId + ' #min-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'max')
              {
                  $(modalId + ' #min-value-field').hide();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'marja')
              {
                  $(modalId + ' #min-value-field').show();
                  $(modalId + ' #max-value-field').show();
                  $(modalId + " .min-max-holder").addClass('input-splitted');
              } 
        });

        $('.critical_number_modal_edit').modal();
    }

    // Initialize prize modal
    function initPrizeModal($entityId)
    {
        var modalId = '.prize_modal_edit';

        var numarCriticEl = '#critical-number-field-edit';
        var targetTypeEl = '#target-type-field-edit';

        var numarCriticValue    = $(numarCriticEl).val();
        var targetTypeValue     = $(targetTypeEl).val();


        if(numarCriticValue == '')
        {
            $(modalId + ' #without-critical-number').show();
            $(modalId + ' #with-critical-number').hide(); 
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }
        else
        {
            $(modalId + ' #without-critical-number').hide();
            $(modalId + ' #with-critical-number').show(); 
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'min')
        {
            $(modalId + ' #max-value-field-edit').hide();
            $(modalId + ' #min-value-field-edit').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'max')
        {
            $(modalId + ' #min-value-field-edit').hide();
            $(modalId + ' #max-value-field').show();
            $(modalId + " .min-max-holder").removeClass('input-splitted');
        }

        if(targetTypeValue == 'marja')
        {
            $(modalId + ' #min-value-field-edit').show();
            $(modalId + ' #max-value-field-edit').show(); 
            $(modalId + " .min-max-holder").addClass('input-splitted');
        }

        $(modalId + ' #target-type-field-edit').change(function(){
            var currentValue = $(this).val();

              if(currentValue == 'min')
              {
                  $(modalId + ' #max-value-field-edit').hide();
                  $(modalId + ' #min-value-field-edit').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'max')
              {
                  $(modalId + ' #min-value-field-edit').hide();
                  $(modalId + ' #max-value-field-edit').show();
                  $(modalId + " .min-max-holder").removeClass('input-splitted');
              }

              if(currentValue == 'marja')
              {
                  $(modalId + ' #min-value-field-edit').show();
                  $(modalId + ' #max-value-field-edit').show();
                  $(modalId + " .min-max-holder").addClass('input-splitted');
              } 
        });

        $(modalId + ' ' + numarCriticEl).change(function(){
            var currentValue = $(this).val();

            if(currentValue == '')
            {
                $(modalId + ' #without-critical-number').show();
                $(modalId + ' #with-critical-number').hide(); 
            }
            else
            {
                $(modalId + ' #without-critical-number').hide();
                $(modalId + ' #with-critical-number').show(); 
            }
        });

        var dateFormat = "mm/dd/yy",
          from = $( "#edit-start_date-prize-field" )
            .datepicker({
              changeMonth: true,
              changeYear: true,
              numberOfMonths: 1,
              firstDay: 1,
            })
            .on( "change", function() {
              to.datepicker( "option", "minDate", getDate( this ) );
            }),
          to = $( "#edit-end_date-prize-field" ).datepicker({
            changeMonth: true,
            changeYear: true,
            numberOfMonths: 1,
            firstDay: 1,
          })
          .on( "change", function() {
            from.datepicker( "option", "maxDate", getDate( this ) );
          });

         $('.prize_modal_edit').modal();


         $('#ajax_form_edit_prize').on('submit',function(e){
          // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
          $.ajaxSetup({
              header:$('meta[name="_token"]').attr('content')
          })
          e.preventDefault(e);
          // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
          var holder = "#" + $(this).attr('id');
          // Butonul de submit al form-ului se pune pe disable pentru ca userul
          // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
          $(holder + ' .btn-primary').addClass('disabled');

          $.ajax({
            type:"POST",
            // Se adauga manual ruta setata la PASUL 4
            url:'/add_prize',
            data: new FormData($(this)[0]),
            dataType: 'HTML',
            processData:false,
            contentType: false,
            headers: { 'X-CSRF-TOKEN': $(this).find('input[name="_token"]').val() },
            success: function(data){
                // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
                $(holder + ' .mesage_form_package').remove();

                var oldPrize = $('#prizes-list .list-row[data-id="' + $entityId + '"]');
                oldPrize.remove();
                // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
                // noua inregistrare
                var prepend_location = $("#prepend_location").val();
                $('#prizes-list').append(data);
                $(prepend_location).parent().find(".btn-default").addClass("add-margin");
                $(holder + ' .btn-primary').removeClass('disabled');
                $(holder).closest('.modal').modal('hide');
                $(holder + " input[type='text']").val('');
            },
            error: function(data){
                var returnedData = JSON.parse(data.responseText);
      $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          $(holder + " .mesage_form_package").append(returnedData["email"]);
          $(holder + ' .btn-primary').removeClass('disabled');
            }
          });
    });
    }

	$('#ajax_form_create_user').on('submit',function(e){
    $(".save-btn").prop('disabled', true);
	  $.ajaxSetup({
	      header:$('meta[name="_token"]').attr('content')
	  })
	  e.preventDefault(e);
	  var holder = "#" + $(this).attr('id');
	  $(holder + ' .btn-primary').addClass('disabled');
	  $.ajax({
	    type:"POST",
	    url:'/create_user_ajax',
	    data:$(this).serialize(),
	    dataType: 'HTML',
	    success: function(data){
			$(holder + ' .alert').remove();
			$(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
			$(holder + " .alert").append(data.responseText);

			$(holder + " input[type='text']").val('');
			$(holder + ' .btn-primary').removeClass('disabled');

	        $(holder + ' .alert').remove();
	        $(holder).closest('.modal').modal('hide');
	        location.reload();

	    },
	    error: function(data){
        $(".save-btn").prop('disabled', false);
	    	var returnedData = JSON.parse(data.responseText);
			$(holder + ' .mesage_form_package').remove();
	        $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
	        $(holder + ' .btn-primary').removeClass('disabled');
			
			$.each(returnedData, function( index, value ) {
	        	$(holder + " .mesage_form_package").append(value + "<br>");
			});
	      	
	    }
	  });
	});

  // ADMIN CREATE USER
  $('#ajax_form_admin_create_user').on('submit',function(e){
    $.ajaxSetup({
        header:$('meta[name="_token"]').attr('content')
    })
    e.preventDefault(e);
    var holder = "#" + $(this).attr('id');
    $(holder + ' .btn-primary').addClass('disabled');
    $.ajax({
      type:"POST",
      url:'/admin/create_user_ajax',
      data:$(this).serialize(),
      dataType: 'HTML',
      success: function(data){
      $(holder + ' .alert').remove();
      $(holder).prepend("<div class='alert alert-success mesage_form_package'></div>");
      $(holder + " .alert").append(data.responseText);

      $(holder + " input[type='text']").val('');
      $(holder + ' .btn-primary').removeClass('disabled');

          $(holder + ' .alert').remove();
          $(holder).closest('.modal').modal('hide');
          location.reload();

      },
      error: function(data){
        var returnedData = JSON.parse(data.responseText);
      $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          $(holder + ' .btn-primary').removeClass('disabled');
      
      $.each(returnedData, function( index, value ) {
            $(holder + " .mesage_form_package").append(value + "<br>");
      });
          
      }
    });
  });


	$('#ajax_form_create_email_notification').on('submit',function(e){
	  $.ajaxSetup({
	      header:$('meta[name="_token"]').attr('content')
	  })
	  e.preventDefault(e);
	  var holder = "#" + $(this).attr('id');
	  $(holder + ' .btn-primary').addClass('disabled');
	  $.ajax({
	    type:"POST",
	    url:'/create_company_email_notifications',
	    data:$(this).serialize(),
	    dataType: 'HTML',
	    success: function(data){
		    $(holder + ' .mesage_form_package').remove();
		    var prepend_location = $("#prepend_location").val();
		    $(prepend_location).append(data);
		    $(prepend_location).parent().find(".btn-default").addClass("add-margin");
		    $(holder + ' .btn-primary').removeClass('disabled');

        	$(holder).closest('.modal').modal('hide');
        	$(holder + " input[type='text']").val('');
	    },
	    error: function(data){
	    	var returnedData = JSON.parse(data.responseText);
			$(holder + ' .mesage_form_package').remove();
	        $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
	        $(holder + " .mesage_form_package").append(returnedData["email"]);
	        $(holder + ' .btn-primary').removeClass('disabled');
	    }
	  });
	});


	$('#ajax_form_create_email_admin').on('submit',function(e){
	  // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
	  $.ajaxSetup({
	      header:$('meta[name="_token"]').attr('content')
	  })
	  e.preventDefault(e);
	  // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
	  var holder = "#" + $(this).attr('id');
	  // Butonul de submit al form-ului se pune pe disable pentru ca userul
	  // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
	  $(holder + ' .btn-primary').addClass('disabled');
	  $.ajax({
	    type:"POST",
	    // Se adauga manual ruta setata la PASUL 4
	    url:'/add_employee_as_admin',
	    data:$(this).serialize(),
	    dataType: 'HTML',
	    success: function(data){
	    	// Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
		    $(holder + ' .mesage_form_package').remove();
		    // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
		    // noua inregistrare
		    var prepend_location = $("#prepend_location").val();
		    $(prepend_location).append(data);
		    $(prepend_location).parent().find(".btn-default").addClass("add-margin");
		    $(holder + ' .btn-primary').removeClass('disabled');
        	$(holder).closest('.modal').modal('hide');
        	$(holder + " input[type='text']").val('');
	    },
	    error: function(data){
	    	// In cazul in care raspunsul primit este un raspuns de eroare
	    	// Atunci trebuie sa afisam eroarea
			$(holder + ' .mesage_form_package').remove();
	        $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
	        $(holder + " .mesage_form_package").append(data.responseText);
	        $(holder + ' .btn-primary').removeClass('disabled');
	    }
	  });
	});
  $(document).on("change","#role-field",function(){
    var checkbox = $(this).parent().parent().find("#intalnire_zilnica-field");
    var checkbox_holder = checkbox.parent().parent();
    if($(this).val() == "captain"){
      checkbox.prop('checked', true);
      checkbox_holder.addClass('hide');
    }else{
      checkbox.prop('checked', false);
      checkbox_holder.removeClass('hide');
    }
  });

  $(document).on("change","#responsible-field",function(){
    var checkbox_wrapper = $(this).parent().parent().find(".with-checkbox");
    if($(this).val() == "team"){
      checkbox_wrapper.find("input").prop('checked', false);
      checkbox_wrapper.addClass('hide');
    }else{
      checkbox_wrapper.removeClass('hide');
    }
  });

	$('#ajax_form_add_team_member').on('submit',function(e){
      // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      })
      e.preventDefault(e);
      // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
      var holder = "#" + $(this).attr('id');
      // Butonul de submit al form-ului se pune pe disable pentru ca userul
      // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
      $(holder + ' .btn-primary').addClass('disabled');
      $.ajax({
        type:"POST",
        // Se adauga manual ruta setata la PASUL 4
        url:'/add_team_member',
        data:$(this).serialize(),
        dataType: 'HTML',
        success: function(data){
            // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
            $(holder + ' .mesage_form_package').remove();
            // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
            // noua inregistrare
            var prepend_location = $("#prepend_location").val();
            $(prepend_location).append(data);
            $(prepend_location).parent().find(".btn-default").addClass("add-margin");
            $(holder + ' .btn-primary').removeClass('disabled');
            $(holder).closest('.modal').modal('hide');
            $(holder + " input[type='text']").val('');

            var lastTeamMember = $(prepend_location + ' .list-row').last();
            
            $('#responsible-field').append($("<option></option>")
                    .attr("value",lastTeamMember.attr('data-user_id'))
                    .text(lastTeamMember.attr('data-email')));
            $(prepend_location + " .example-row").addClass('hide');
        },
        error: function(data){
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
            $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
            $(holder + ' .btn-primary').removeClass('disabled');
      
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "</br>");
            });

            $(holder + ' .btn-primary').removeClass('disabled');
        }
      });
    });

   // REMOVE A TEAM-MEMBER FROM OBJECTIVES DB
    $(document).on('click', '#remove-team-member', function(e) {
      e.preventDefault();

      var userId = $(this).attr('rel');
      $('#team-members-list').find('.list-row[data-id="'+ userId + '"]').remove();

      $.ajax({
        type:"GET",
        url:'/remove_team_member/'+$(this).attr('rel'),
        dataType: 'JSON',
        success: function(data)
        {
          $('.team_member_modal_edit').modal('hide');
          $('#responsible-field option[value=' + userId + ']').remove();
          $count_records = $("#team-members-list .list-row").length;
          if($count_records == 1){
            $("#team-members-list .example-row").removeClass('hide');
          }
        },
        error: function(data){
          console.log("SOMETHING WENT WRONG");
        }
      });
    });




    $('#ajax_form_add_strategic_action').on('submit',function(e){
      // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      })
      e.preventDefault(e);
      // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
      var holder = "#" + $(this).attr('id');
      // Butonul de submit al form-ului se pune pe disable pentru ca userul
      // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
      $(holder + ' .btn-primary').addClass('disabled');
      $.ajax({
        type:"POST",
        // Se adauga manual ruta setata la PASUL 4
        url:'/add_strategic_action',
        data:$(this).serialize(),
        dataType: 'HTML',
        success: function(data){
            // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
            $(holder + ' .mesage_form_package').remove();
            // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
            // noua inregistrare
            var prepend_location = $("#prepend_location").val();
            $(prepend_location).append(data);
            $(prepend_location).parent().find(".btn-default").addClass("add-margin");
            $(holder + ' .btn-primary').removeClass('disabled');
            $(holder).closest('.modal').modal('hide');
            $(holder + " input[type='text']").val('');
            $(prepend_location + " .example-row").addClass('hide');
        },
        error: function(data){
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
            $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
            $(holder + ' .btn-primary').removeClass('disabled');
      
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "</br>");
            });

            $(holder + ' .btn-primary').removeClass('disabled');
        }
      });
    });

   // REMOVE A STRATEGIC ACTION FROM OBJECTIVES DB
    $(document).on('click', '#remove-strategic-action', function(e) {
      e.preventDefault();
      
      var strategicActionId = $(this).attr('rel');

    $.ajax({
        type:"GET",
        url:'/remove_strategic_action/'+$(this).attr('rel'),
        dataType: 'JSON',
        success: function(data){
          $('#strategic-actions-list').find('.list-row[data-id="'+ strategicActionId + '"]').remove();
          $('.strategic_action_modal_edit').modal('hide');
          $count_records = $("#strategic-actions-list .list-row").length;
          if($count_records == 1){
            $("#strategic-actions-list .example-row").removeClass('hide');
          }
          console.log('Strategic action removed')
        },
        error: function(data){
          console.log("SOMETHING WENT WRONG");
        }
      });
    });

    $('#ajax_form_add_critical_number').on('submit',function(e){
      // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      })
      e.preventDefault(e);
      // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
      var holder = "#" + $(this).attr('id');
      // Butonul de submit al form-ului se pune pe disable pentru ca userul
      // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
      $(holder + ' .btn-primary').addClass('disabled');
      $.ajax({
        type:"POST",
        // Se adauga manual ruta setata la PASUL 4
        url:'/add_critical_number',
        data:$(this).serialize(),
        dataType: 'HTML',
        success: function(data){
            // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
            $(holder + ' .mesage_form_package').remove();
            // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
            // noua inregistrare
            var prepend_location = $("#prepend_location").val();
            $(prepend_location).append(data);
            $(prepend_location).parent().find(".btn-default").addClass("add-margin");
            $(holder + ' .btn-primary').removeClass('disabled');
            $(holder).closest('.modal').modal('hide');
            $(holder + " input[type='text']").val('');
            $(holder + " input#initial_value-field").val('0');
            reinitCriticalNumberDays(holder);

            var lastCriticalNumber = $(prepend_location + ' .list-row').last();
            
            $('#add_prize #critical-number-field').append($("<option></option>")
                    .attr("value",lastCriticalNumber.attr('data-id'))
                    .text(lastCriticalNumber.attr('data-name')));
            $(prepend_location + " .example-row").addClass('hide');
        },
        error: function(data){
            // In cazul in care raspunsul primit este un raspuns de eroare
            // Atunci trebuie sa afisam eroarea
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
            $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
            $(holder + ' .btn-primary').removeClass('disabled');
      
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "</br>");
            });

            $(holder + ' .btn-primary').removeClass('disabled');
        }
      });
    });
    // REMOVE A CRITICAL NUMBER FROM OBJECTIVES DB
    $(document).on('click', '#remove-critical-number', function(e) {
      e.preventDefault();
      $(this).closest('.list-row').remove();

      var criticalNumberId = $(this).attr('rel');

      $.ajax({
        type:"GET",
        url:'/remove_critical_number/'+$(this).attr('rel'),
        dataType: 'JSON',
        success: function(data)
        {
           $('#critical-numbers-list').find('.list-row[data-id="'+ criticalNumberId + '"]').remove();
           $('#add_prize #critical-number-field option[value=' + criticalNumberId + ']').remove();

           $('.critical_number_modal_edit').modal('hide');
            $count_records = $("#critical-numbers-list .list-row").length;
            if($count_records == 1){
              $("#critical-numbers-list .example-row").removeClass('hide');
            }
          console.log('Critical number removed')
        },
        error: function(data){
          console.log("SOMETHING WENT WRONG");
        }
      });
    });


    $('#ajax_form_add_prize').on('submit',function(e){
      // Pentru ca ajax-ul sa functioneze trebuie adaugata token-ul
      $.ajaxSetup({
          header:$('meta[name="_token"]').attr('content')
      })
      e.preventDefault(e);
      // variabila holder pastreaza id-ul form-ul care se submite in aceasta functie
      var holder = "#" + $(this).attr('id');
      // Butonul de submit al form-ului se pune pe disable pentru ca userul
      // Sa nu poata sa dea click-uri pana ce nu primeste un raspuns de la server
      $(holder + ' .btn-primary').addClass('disabled');
      $.ajax({
        type:"POST",
        // Se adauga manual ruta setata la PASUL 4
        url:'/add_prize',
        data: new FormData($(this)[0]),
        dataType: 'HTML',
        processData:false,
        contentType: false,
        headers: { 'X-CSRF-TOKEN': $(this).find('input[name="_token"]').val() },
        success: function(data){
            $('#ajax_form_add_prize')[0].reset();

            var $el = $('#image-field');
            $el.wrap('<form>').closest('form').get(0).reset();
            $el.unwrap()

            // Trebuie sa stergem mesajul de eroare daca acesta a aparut la primul submit
            $(holder + ' .mesage_form_package').remove();
            // La PUNCTUL 3, completasem inputul prepend_location cu numele div-ului ce va avea
            // noua inregistrare
            var prepend_location = $("#prepend_location").val();
            $(prepend_location).append(data);
            $(prepend_location).parent().find(".btn-default").addClass("add-margin");
            $(holder + ' .btn-primary').removeClass('disabled');
            $(holder).closest('.modal').modal('hide');
            $(holder + " input[type='text']").val('');
            $(prepend_location + " .example-row").addClass('hide');
        },
        error: function(data){
            // In cazul in care raspunsul primit este un raspuns de eroare
            // Atunci trebuie sa afisam eroarea
            var returnedData = JSON.parse(data.responseText);
            $(holder + ' .mesage_form_package').remove();
            $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
            $(holder + ' .btn-primary').removeClass('disabled');
      
            $.each(returnedData, function( index, value ) {
                  $(holder + " .mesage_form_package").append(value + "</br>");
            });

            $(holder + ' .btn-primary').removeClass('disabled');
        }
      });
    });

    // REMOVE A CRITICAL NUMBER FROM OBJECTIVES DB
    $(document).on('click', '#remove-prize', function(e) {
      e.preventDefault();
    
      var prizeId = $(this).attr('rel');

      $.ajax({
        type:"GET",
        url:'/remove_prize/'+$(this).attr('rel'),
        dataType: 'JSON',
        success: function(data)
        {
            $('#prizes-list').find('.list-row[data-id="'+ prizeId + '"]').remove();
            $('.prize_modal_edit').modal('hide');
            $count_records = $("#prizes-list .list-row").length;
            if($count_records == 1){
              $("#prizes-list .example-row").removeClass('hide');
            }
          console.log('Prize removed')
        },
        error: function(data){
          console.log("SOMETHING WENT WRONG");
        }
      });
    });

    // MULTIPLE DAYS PICKER FROM DROPDOWN
    $(document).on("click", ".choose-days, .choose-start-hour, .choose-week_days", function(){
      $(this).parent().find(".checklist").toggleClass("show");
    });
    
    $(document).on("click", ".check-days a", function(){
      $(this).toggleClass('checked');

      var list = '';
      var counter = 0;
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
            }else{
              list += "," + current_elem.attr('rel');
            } 
            counter += 1;
          }
      });
      $(this).parent().parent().find('.choose-days span').html(counter);
      $("#target_days").val(list);
    });

    $(document).on("click", ".cn-check-days a", function(){
      $(this).toggleClass('checked');

      var list = '';
      var span_text = '';
      var counter = 0;
      $(this).parent().find('.dropdown-item').each(function(){
          var current_elem = $(this);
          if ($(this).hasClass('checked')) {
            if(list == ''){
              list += current_elem.attr('rel');
              span_text += current_elem.html();
            }else{
              list += "," + current_elem.attr('rel');
              span_text += ", " + current_elem.html();
            } 
          }
      });
      $(this).parent().parent().find('.choose-days span').html(span_text);
      $(this).parent().parent().parent().find("#cn_target_days").val(list);
    });
    
    $(document).mouseup(function(e) 
    {
        var container = $(".dropdown-item");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
          if($(".cn-check-days").hasClass('show')){
            $(".cn-check-days").removeClass('show');
          }
          if($(".check-start-hour").hasClass('show')){
            $(".check-start-hour").removeClass('show');
          }
          if($(".check-days").hasClass('show')){
            $(".check-days").removeClass('show');
          }
        }
    });


    $(".check-start-hour a").click(function(){
      $(".check-start-hour a").removeClass('checked');
      $(this).toggleClass('checked');
      $(this).parent().parent().find('.choose-start-hour').html($(this).text());
      $("#start_hour").val($(this).text());
    });


    // REMOVE A COMPANY NOTIFICATION FROM DB
    $(document).on('click', '.remove-alert-row', function(e) {
      e.preventDefault();
      $(this).closest('.list-row').remove();
		$.ajax({
		    type:"GET",
		    url:'/delete_company_notification_email/'+$(this).attr('rel'),
		    dataType: 'JSON',
		    success: function(data){
			    console.log("EMAIL HAS BEEN DELETED");
		    },
		    error: function(data){
		    	console.log("SOMETHING WENT WRONG");
		    }
	  	});
    });

    // REMOVE A COMPANY ADMIN FROM DB
    $(document).on('click', '.remove-admin-row', function(e) {
      e.preventDefault();
      $(this).closest('.list-row').remove();
    $.ajax({
        type:"GET",
        url:'/delete_employee_as_admin/'+$(this).attr('rel'),
        dataType: 'JSON',
        success: function(data){
          console.log("EMAIL HAS BEEN REMOVED");
        },
        error: function(data){
          console.log("SOMETHING WENT WRONG");
        }
      });
    });

    $(document).on('click', '.display-notification-modal', function(e) {
      $("#notification-type").val($(this).attr('rel'));
      $("#prepend_location").val($(this).data('position'));
    });

    $(".filter-holder select").change(function() {
	  $(this).parent().submit();
	});

  // CHOOSE OBJECTIVE BUTTON
  $(".go-to-meeting-btn").click(function(e){
    e.preventDefault;
    var href = $("#choose-objective-for-daily-meeting").find('option:selected').attr('rel');
    window.location.href = href ;
  });

  // Target Type -> show MIN MAX inputs

  $(document).on('change', '#target-type-field', function(){
    var currentValue = $(this).val();

    if(currentValue == 'min')
    {
        $(' #max-value-field').hide();
        $(' #min-value-field').show();
        $(" .min-max-holder").removeClass('input-splitted');
    }

    if(currentValue == 'max')
    {
        $(' #min-value-field').hide();
        $(' #max-value-field').show();
        $(" .min-max-holder").removeClass('input-splitted');
    }

    if(currentValue == 'marja')
    {
        $(' #min-value-field').show();
        $(' #max-value-field').show();
        $(" .min-max-holder").addClass('input-splitted');
    } 
  });

  // Calendar change date 
  $('.calendar-picker-input').datepicker({
      dateFormat: 'yy-mm-dd',
      todayHighlight: true,
      beforeShowDay: disableDays,
      language: 'ro',
      disableTouchKeyboard: true,
      firstDay: 1,
      minDate: $('.calendar-picker-input').data('min_date'),
      maxDate: $('.calendar-picker-input').data('max_date')
  }).on('change', function(){
      $('#day-selected').val($(this).val());
      $("#all_plans_list").submit();
  });
});

function disableDays(date) {
    var disabled_days_string = $('.dates_daily_meeting_realized_str').val();
    var disabled_days = disabled_days_string.split(",");
    for (var i = 0; i < disabled_days.length; i++) {
      if (new Date(disabled_days[i]).toString() == date.toString()) {              
          return [true, 'disabled_days_datepicker'];
      }
    }
    return [true, ''];
 } 

// START DATE - END DATE Range
$( function() {
    var dateFormat = "yy-mm-dd",
      objective_start_date = $( "#start_date-field" )
        .datepicker({
          dateFormat: dateFormat,
          minDate: 0,
          changeMonth: true,
          changeYear: true,
          numberOfMonths: 1
        })
        .on( "change", function() {
          if( objective_end_date.val() != "" && ($(this).val() > objective_end_date.val()) ){
            objective_end_date.datepicker( "option", "minDate", getDate( this ) );
          }
          prize_start_date.val($(this).val());
          prize_start_date.datepicker( "option", "minDate", getDate( this ) );
          prize_end_date.datepicker( "option", "minDate", getDate( this ) );
        }),
      objective_end_date = $( "#end_date-field" ).datepicker({
          dateFormat: dateFormat,
        defaultDate: "+1d",
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1
      })
      .on( "change", function() {
          objective_start_date.datepicker( "option", "maxDate", getDate( this ) );
          prize_start_date.datepicker( "option", "maxDate", getDate( this ) );
          prize_end_date.val($(this).val());
          prize_end_date.datepicker( "option", "maxDate", getDate( this ) );
      });

      prize_start_date = $( "#start_date-prize-field" )
        .datepicker({
          dateFormat: dateFormat,
          defaultDate: "+1d",
          changeMonth: true,
          changeYear: true,
          numberOfMonths: 1
        })
        .on( "change", function() {
          prize_end_date.datepicker( "option", "minDate", getDate( this ) );
        }),
      prize_end_date = $( "#end_date-prize-field" ).datepicker({
        dateFormat: dateFormat, 
        defaultDate: "+1d",
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1
      })
      .on( "change", function() {
        prize_start_date.datepicker( "option", "maxDate", getDate( this ) );
      });
 
 
  });

